import styled from 'styled-components'
import { RiSunLine, RiMoonLine } from 'react-icons/ri'
import useTheme from '../../hooks/useTheme'
import { media } from '../../styles/media'
import { saveToLS } from '../../utils/localStore/localStore'

const Pill = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.area.bg};
  border-radius: 2rem;
  padding: 4px;
  gap: 2px;

  ${media.phone} {
    padding-inline: 0px;
  }

`

const IconButton = styled.button`
  border-radius: 50%;
  background-color: ${({ $active, theme }) => $active ? theme.dropdown.active : 'transparent'};
  color: ${({ $active, theme }) => $active ? theme.font.highlight : theme.font.label};
  border: none;
  width: 32px;
  height: 32px;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
  &:hover {
    background: ${({ $active, theme }) => $active ? theme.dropdown.active : theme.dropdown.selectedBackground};
  }

  ${media.phone} {
    display: ${({ $active }) => $active ? 'none' : 'flex'};
  }
`

function ThemeToggle() {
  const { ThemeContext: tCtx, currentMode } = useTheme()

  const setMode = (mode) => {
    saveToLS('Theme', 'themeMode', mode)
    saveToLS('Theme', 'themeNavMode', mode)
    tCtx.currentMode = mode
    tCtx.currentNavMode = mode
  }

  return (
    <Pill>
      <IconButton
        $active={currentMode === 'light'}
        onClick={() => setMode('light')}
        data-testid='theme.light'
      >
        <RiSunLine />
      </IconButton>
      <IconButton
        $active={currentMode === 'dark'}
        onClick={() => setMode('dark')}
        data-testid='theme.dark'
      >
        <RiMoonLine />
      </IconButton>
    </Pill>
  )
}

export default ThemeToggle
